module.exports = __webpack_public_path__ + "assets/ic-calendar.99f4e057.svg";